<template>
	<div style="height: 100%;">
		<t-tab-list :selected.sync="internalSelected" :items="tabs" :marginBottom="marginBottom">
			<template v-slot="{item, isSelected, sidebar}">
				<t-tab
					:value="item"
					:selected="isSelected"
					:sidebar="sidebar"
					:tabindex="disableTabbing ? -1 : 0"
				>
					{{item.label}}
				</t-tab>
			</template>
		</t-tab-list>

		<t-pane v-bind="paneOptions">
			<transition name="fade" mode="out-in">
				<component
					:is="internalSelected.component"
					v-if="internalSelected"
					:value="internalSelected.value"
					v-bind="$attrs"
					:events="internalSelected.events"
					v-on="$listeners"
				/>
			</transition>
		</t-pane>
	</div>
</template>

<script>
export default {
	name: 'TTabView',
	inheritAttrs: false,
	props: {
		tabs: Array,
		tabStyle: Object,
		paneOptions: {
			type: Object,
			default() {
				return {
					height: 'calc(100% - 48px)',
					border: 'default',
					background: 'tint2',
					borderRadius: '5px',
					style: { overflow: 'hidden', }
				};
			}
		},
		marginBottom: String,
		disableTabbing: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return { internalSelected: this.tabs[0] || undefined, };
	},
};
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .15s ease;
}

.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>
